var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Metamask",
    transform: "translate(-146 -328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 68,
    height: 68,
    transform: "translate(146 328)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "custom-fox-9141676",
    transform: "translate(158 342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M354.185,69.83l-6.4,0-2.522-6.105Z",
    transform: "translate(-328.803 -57.624)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M345.266,63.661l11.484-.012-2.565,6.112Z",
    transform: "translate(-328.803 -57.556)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M269.758,35.131l-16.135-12.16,13.614,6.055Z",
    transform: "translate(-250.774 -22.92)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M421.454,22.629,405.306,34.835l2.565-6.112Z",
    transform: "translate(-379.924 -22.629)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M253.606,118.7l-7.3-1.887-.4-1.708Z",
    transform: "translate(-244.209 -101.371)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M248.834,128.656l-.255-2.051,7.3,1.887Z",
    transform: "translate(-246.479 -111.159)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M257.216,142.429l6.015-3.123,3.143.577Z",
    transform: "translate(-253.833 -121.973)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M250.3,139.47l7.043-.164-6.015,3.123Z",
    transform: "translate(-247.941 -121.973)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M470.168,118.531l7.7-3.609-.4,1.711Z",
    transform: "translate(-435.151 -101.211)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M320.325,261.8l2.369-1.3.4-.129Z",
    transform: "translate(-307.567 -225.046)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M477.213,128.5l-7.045-.158,7.3-1.9Z",
    transform: "translate(-435.151 -111.021)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M458.051,142.341l-9.177-2.542,3.163-.581Z",
    transform: "translate(-417.02 -121.898)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M477.213,139.376l-1.031,2.965-6.014-3.123Z",
    transform: "translate(-435.151 -121.898)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M428.9,260.392l.38.13,2.339,1.307Z",
    transform: "translate(-400.014 -225.071)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M253.919,77.06l-.313,9.247-7.694-3.595Z",
    transform: "translate(-244.209 -68.974)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M300.85,86.884l-3.143-.577.313-9.247Z",
    transform: "translate(-288.309 -68.974)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M475.9,82.55l-7.7,3.609-.344-9.257Z",
    transform: "translate(-433.179 -68.839)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M451.693,76.9l.344,9.257-3.163.581Z",
    transform: "translate(-417.02 -68.839)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M247.2,232.8l-10.232,3.718L234.445,226.3Z",
    transform: "translate(-234.445 -196.046)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M460.042,226.331l-2.527,10.229-10.307-3.733Z",
    transform: "translate(-415.601 -196.07)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M239.524,115.73l.949-.621.4,1.708Z",
    transform: "translate(-238.77 -101.371)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M299.811,77.06l9.274,4.125-6.444,5.7Z",
    transform: "translate(-290.101 -68.974)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M411.778,86.74l-6.472-5.695L414.6,76.9Z",
    transform: "translate(-379.924 -68.839)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M520.666,115.543l-1.347,1.091.4-1.711Z",
    transform: "translate(-477 -101.211)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M242.666,128.656l-1.331-1.3,1.076-.753Z",
    transform: "translate(-240.312 -111.159)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M517.59,128.5l.257-2.055,1.077.754Z",
    transform: "translate(-475.528 -111.021)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M239.06,74.318l-1.2-7.117,9.2,1.465Z",
    transform: "translate(-237.357 -60.58)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M246.277,143.372l-1.909-2.386.881-.573Z",
    transform: "translate(-242.894 -122.916)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M467.853,68.391l9.227-1.485L475.9,74.039Z",
    transform: "translate(-433.179 -60.329)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M244.15,161.045l-9.7,9.088,3.383-9.8Z",
    transform: "translate(-234.445 -139.876)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M510.649,143.244l1.031-2.965.881.574Z",
    transform: "translate(-469.618 -122.802)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M467.672,160.957l6.384-.718,3.409,9.818Z",
    transform: "translate(-433.025 -139.796)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M242.638,173.1l-8.193,1.113,9.7-9.088Z",
    transform: "translate(-234.445 -143.96)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M234.445,219.926l8.193-1.113,4.565,7.606Z",
    transform: "translate(-234.445 -189.669)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M467.672,165.074l9.794,9.1-8.281-1.116Z",
    transform: "translate(-433.025 -143.913)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M447.208,226.433l4.553-7.612,8.281,1.116Z",
    transform: "translate(-415.601 -189.676)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M257.216,145.737l9.158-2.546-2.835,3.259Z",
    transform: "translate(-253.833 -125.281)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M458.051,145.67l-6.384.718-2.793-3.26Z",
    transform: "translate(-417.02 -125.227)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M318.861,110.526l6.444-5.7.51,9.036Z",
    transform: "translate(-306.321 -92.616)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M309.564,146.528l-9.79-.078,2.835-3.259Z",
    transform: "translate(-290.069 -125.281)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M408.581,143.128l2.793,3.26-9.823.084Z",
    transform: "translate(-376.727 -125.227)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M401.551,113.834l.558-9.039,6.472,5.695Z",
    transform: "translate(-376.727 -92.589)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M253.623,22.971l16.135,12.16-9.274-4.125Z",
    transform: "translate(-250.774 -22.92)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M247.067,31.006l-9.2-1.465,2.341-6.571Z",
    transform: "translate(-237.357 -22.92)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M474.709,22.629l2.371,6.578-9.227,1.485Z",
    transform: "translate(-433.179 -22.629)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M414.6,30.691l-9.292,4.144,16.148-12.206Z",
    transform: "translate(-379.924 -22.629)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M362.24,104.8l6.4,0-.558,9.039Z",
    transform: "translate(-343.256 -92.589)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M368.08,113.861l-5.33,0-.51-9.036Z",
    transform: "translate(-343.256 -92.616)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M294.159,225.038l-4.565-7.606,5.5-.241Z",
    transform: "translate(-281.401 -188.288)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M441.635,225.049l-.972-7.854,5.525.242Z",
    transform: "translate(-410.029 -188.291)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M303.672,168.92l-3.9-3.791,9.79.078Z",
    transform: "translate(-290.069 -143.96)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M401.551,165.158l9.823-.084-3.919,3.8Z",
    transform: "translate(-376.727 -143.913)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M291.106,165.129l3.984,7.734-5.5.241Z",
    transform: "translate(-281.401 -143.96)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M299.774,165.129l3.9,3.791.086,3.943Z",
    transform: "translate(-290.069 -143.96)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M446.188,173.058l-5.525-.242,4.012-7.743Z",
    transform: "translate(-410.029 -143.913)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M444.675,165.074l-4.012,7.743.093-3.947Z",
    transform: "translate(-410.029 -143.913)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M322.263,271.158l-1.938-1.146,5.581.542Z",
    transform: "translate(-307.567 -233.262)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M408.781,270.6l5.708-.537-1.968,1.146Z",
    transform: "translate(-382.883 -233.305)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M325.859,259.145l.047,2.156-5.581-.542Z",
    transform: "translate(-307.567 -224.01)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M331.9,165.653l-2.373,2.073-3.519,1.639Z",
    transform: "translate(-312.409 -144.406)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M326.352,219.334l-6.027,5.7.931-7.847Z",
    transform: "translate(-307.567 -188.288)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M320.325,237.319l6.027-5.7-.493,4.09Z",
    transform: "translate(-307.567 -200.569)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M408.8,259.161l5.685,1.619-5.708.537Z",
    transform: "translate(-382.883 -224.023)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M407.455,169.353l-3.526-1.639-2.377-2.073Z",
    transform: "translate(-376.727 -144.396)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M405.6,219.338l5.209-2.143.972,7.854Z",
    transform: "translate(-380.171 -188.291)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M411.778,237.331l-5.685-1.619-.5-4.091Z",
    transform: "translate(-380.171 -200.574)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M326.1,194.589l-.086-3.943,4.954,1.217Z",
    transform: "translate(-312.409 -165.686)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M330.966,182.466l-4.954-1.217,3.519-1.639Z",
    transform: "translate(-312.409 -156.29)",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M412.689,194.575l-4.881-2.728,4.974-1.219Z",
    transform: "translate(-382.054 -165.671)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M407.808,182.452l1.448-2.858,3.526,1.639Z",
    transform: "translate(-382.054 -156.276)",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M349.7,167.726l2.373-2.073-.938,4.929Z",
    transform: "translate(-332.58 -144.406)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M403.928,167.714l-1.448,2.858-.93-4.931Z",
    transform: "translate(-376.727 -144.396)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M365.876,168.493l-.2-2.85,5.33,0Z",
    transform: "translate(-346.18 -144.396)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M359.361,170.582l.938-4.929.2,2.85Z",
    transform: "translate(-340.804 -144.406)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M372.159,165.641l-.221,2.851h-4.907Z",
    transform: "translate(-347.335 -144.396)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M401.216,170.572l-1.15-2.08.221-2.851Z",
    transform: "translate(-375.462 -144.396)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M337.013,273.658l.325,1.663-3.969-1.058Z",
    transform: "translate(-318.674 -236.367)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M410.622,274.287l-4.072,1.055.331-1.663Z",
    transform: "translate(-380.983 -236.384)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M331.69,203.705l-5.1-2.143,4.868-2.727Z",
    transform: "translate(-312.905 -172.66)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M405.925,198.832l4.881,2.728L405.6,203.7Z",
    transform: "translate(-380.171 -172.656)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M360.5,184.839l-.054,6.352-1.085-4.272Z",
    transform: "translate(-340.804 -160.742)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M359.361,198.836l1.085,4.272-.857.6Z",
    transform: "translate(-340.804 -172.66)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M399.859,184.833l1.15,2.08-1.186,4.273Z",
    transform: "translate(-375.256 -160.737)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M400.681,203.7l-.858-.6,1.186-4.273Z",
    transform: "translate(-375.256 -172.656)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M367.031,184.834h4.907l-.036,6.353Z",
    transform: "translate(-347.335 -160.737)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M371.592,191.191h-4.925l.054-6.352Z",
    transform: "translate(-347.025 -160.742)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M357.95,262.964l-.325-1.663-.047-2.156Z",
    transform: "translate(-339.285 -224.01)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M406.9,259.161l-.023,2.157-.331,1.663Z",
    transform: "translate(-380.983 -224.023)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M357.577,255.577l.438-.622-.065,4.441Z",
    transform: "translate(-339.285 -220.442)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M360.086,259.4l.065-4.441,6.742,0Z",
    transform: "translate(-341.422 -220.442)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M366.893,254.968l.095,4.443-6.9,0Z",
    transform: "translate(-341.422 -220.453)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M406.006,259.411l-.095-4.443.45.623Z",
    transform: "translate(-380.439 -220.453)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M358.015,235.082l-.438.622.493-4.09Z",
    transform: "translate(-339.285 -200.569)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M405.6,231.62l.5,4.091-.45-.623Z",
    transform: "translate(-380.171 -200.574)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M366.271,228l.059-.4h4.925Z",
    transform: "translate(-346.688 -197.146)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M360.9,228.192l.857-.6-.059.4Z",
    transform: "translate(-342.112 -197.146)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M371.255,227.6l.036.4h-5.02Z",
    transform: "translate(-346.688 -197.149)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M399.859,228l-.036-.4.858.6Z",
    transform: "translate(-375.256 -197.149)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M360.579,231.615l.249.423-.3,3.044Z",
    transform: "translate(-341.795 -200.569)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M361.7,230.293l-.549.619-.249-.423Z",
    transform: "translate(-342.112 -199.444)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M404.079,235.088l-.32-3.045.273-.423Z",
    transform: "translate(-378.607 -200.574)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M400.886,230.494l-.273.423-.549-.62Z",
    transform: "translate(-375.461 -199.447)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M367.266,237.509l-6.742,0,.3-3.044Z",
    transform: "translate(-341.795 -202.994)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M362.576,234.463h6.118l.32,3.045Z",
    transform: "translate(-343.542 -202.994)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M362.576,230.912l.549-.619h5.02Z",
    transform: "translate(-343.542 -199.444)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M368.145,230.3l.549.62h-6.118Z",
    transform: "translate(-343.542 -199.447)",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.63471e2c05df922fbacc92001413910d.svg";
export { ForwardRef as ReactComponent };